var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEWinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "28px",
    viewBox: "0 0 72.0 28.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,0 L72,28 L0,28 L0,0 L72,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6306,0 L6.3732,0.035 L6.8876,2.1394 C4.82633403,3.4212422 2.29982146,3.71407497 0,2.9377 L0.0891,2.0761 L2.6306,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61,0 L5.107,0.274 L6.648,3.568 L5.092,6.438 L1.382,6.404 L0,3.5 L0.207,3.049 L1.61,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.302,0 C2.79588912,1.51734655 3.63212579,3.56197161 3.62970526,5.6913 C3.62970526,5.96688876 3.61587096,6.24230393 3.5882,6.5165 L1.5589,6.5165 L0,3.1865 L0.6673,0.2361 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.699,0 L5.057,0.103 L6.042,2.685 L4.585,5.853 L4.428,6.193 L1.72,5.898 L1.003,5.82 L0,2.636 L1.699,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.15121853,0 L2.15851853,3.1959 L1.69761853,6.2814 L1.07421853,6.5114 C-0.0357381134,4.57259113 -0.298774498,2.26240618 0.346918526,0.1237 L1.15121853,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4822,0 L3.3905,2.3128 L3.3277,2.9199 C1.99258992,2.32113115 0.843179889,1.37416401 0,0.1783 L0.4822,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2064,0 L2.2811,0.259 L0.5555,2.9352 L0,3.0207 C0.491236601,1.85630564 1.24661078,0.822151006 2.2064,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0078,0 C1.13338947,0.303053128 2.18034305,0.845392412 3.0772,1.59 L2.7611,1.7076 L0,0.2928 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13,0 C2.74795373,1.94136727 1.67055677,3.67658085 0.1,4.88 L0,4.6432 L1.0206,3.5254 C1.68392355,2.66315879 2.22058487,1.71052349 2.6143,0.6964 L2.8421,0.11 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.46767689 C1.75381247,0.238561952 3.92282033,-0.246427786 6.0331,0.11867689 L6.0209,0.58077689 L3.5659,2.01877689 L0.1287,1.91367689 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3011853,0.344795767 C19.5315227,0.0642224691 19.9024257,-0.0592822529 20.2549853,0.027195767 C20.3229244,0.0409332483 20.3897691,0.0596163183 20.4549853,0.083095767 C20.7202433,0.189538686 20.9672004,0.336855891 21.1868853,0.519695767 C24.7349853,3.26599577 26.1946853,8.60759577 25.8695853,12.9423958 C25.2268853,21.5134958 19.4376853,25.9229958 13.0403853,25.8043958 L12.8732853,25.8043958 C6.4759853,25.9229958 0.686885303,21.5134958 0.0441853034,12.9423958 C-0.280914697,8.60759577 1.1787853,3.26599577 4.7275853,0.519695767 C4.94721971,0.336836538 5.19414709,0.189516924 5.4593853,0.083095767 C5.52460707,0.0596335819 5.59145041,0.0409508675 5.6593853,0.027195767 C6.01191544,-0.0592909823 6.38279432,0.0642186454 6.6130853,0.344795767 C6.9172853,0.777995767 6.6619853,1.36889577 6.4036853,1.83079577 C5.27833074,3.52781347 4.35890079,5.35270852 3.6647853,7.26699577 C2.71360437,10.6383529 3.26172987,14.2561051 5.1688853,17.1943958 C6.87641949,19.7952441 9.76233714,21.3803187 12.8732853,21.4259958 L13.0403853,21.4259958 C16.1513505,21.3802816 19.0372821,19.7952199 20.7448853,17.1943958 C22.6520407,14.2561051 23.2001662,10.6383529 22.2489853,7.26699577 C21.555217,5.35275999 20.6361574,3.52786704 19.5111853,1.83079577 C19.2523853,1.36889577 18.9970853,0.777995767 19.3011853,0.344795767 Z M3.2169853,16.8651958 L2.2625853,17.3173958 L2.9910853,18.8548958 L3.9454853,18.4027958 L3.2169853,16.8651958 Z M22.6967853,16.8651958 L21.9682853,18.4027958 L22.9225853,18.8548958 L23.6510853,17.3173958 L22.6967853,16.8651958 Z M2.1668853,12.8295958 L1.1234853,12.9936958 L1.3879853,14.6743958 L2.4311853,14.5102958 L2.1668853,12.8295958 Z M23.7469853,12.8300958 L23.4827853,14.5107958 L24.5259853,14.6748958 L24.7901853,12.9941958 L23.7469853,12.8300958 Z M24.7731853,8.70739577 L23.7191853,8.77339577 L23.8253853,10.4713958 L24.8793853,10.4054958 L24.7731853,8.70739577 Z M1.1405853,8.70689577 L1.0342853,10.4049958 L2.0882853,10.4708958 L2.1945853,8.77289577 L1.1405853,8.70689577 Z M2.5968853,4.43599577 L1.9299853,6.00189577 L2.9014853,6.41599577 L3.5683853,4.84999577 L2.5968853,4.43599577 Z M23.3168853,4.43599577 L22.3451853,4.85029577 L23.0124853,6.41519577 L23.9838853,6.00109577 L23.3168853,4.43599577 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23722173,2.55331218 L1.70101675,6.1417469 C3.02355299,8.97469846 7.28171218,6.7348681 7.11119093,4.01942307 L8.22319617,3.45630354 C8.26301171,3.78859181 8.27082286,4.12391243 8.24652289,4.45768272 C7.92629727,8.75027422 1.54762145,10.9942225 0.149347202,5.89893929 C-1.11679153,1.28250627 6.0208884,-2.83434017 8.23722173,2.55331218 Z M1.38536789,4.70446114 L1.38713954,4.71519703 L6.31837785,2.24094188 C4.75799769,-0.00109448034 0.934040223,2.21461689 1.38536789,4.70446114 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82233346,0 L3.7042235,6.75478716 L3.9242033,6.75478716 L7.90450882,0 L11.0093243,0 L10.8956435,6.60330815 L11.0373754,6.60330815 L14.6781148,0 L16.0452376,0 L9.13285237,11.8300692 L7.15303422,11.8300692 L7.21651833,5.66207937 L7.13088861,5.6606087 L3.32774802,11.8300692 L0,11.8300692 L0.25541278,0 L3.82233346,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00245114,0 L3.11219735,1.97216842 L0,1.97216842 L0.888777421,0 L4.00245114,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58856469,0 L3.11367372,8.63871538 L0,8.63871538 L4.47489097,0 L7.58856469,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.343081,1.65504649 L12.1892428,1.94918049 L8.73998912,8.68234879 L5.90357853,8.68234879 C6.8434385,6.84798214 7.82183185,5.02832219 8.72345373,3.1754251 C8.85015917,2.9504492 8.93098854,2.70275054 8.96129765,2.44656107 C8.98873651,2.1847419 8.86740366,1.92951516 8.64668226,1.78475958 C8.47618975,1.70741463 8.28590614,1.68430524 8.10175245,1.71857944 C7.46976374,1.79269979 6.87131353,2.04190581 6.37439434,2.43788412 C5.98964902,2.76395725 5.68475083,3.17326009 5.48295944,3.63456827 L4.23114154,6.05396743 L2.86889084,8.68323119 L0,8.68323119 L4.47341459,0.0449570136 L7.34245307,0.0449570136 L6.68221841,1.31899841 C7.37539132,0.801925067 8.16578045,0.428837313 9.00647471,0.221878611 C9.59097136,0.0595166462 13.2923897,-0.622138883 12.343081,1.65504649 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.35898530339327 16.70869576698334)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.8876,0 6.8876,3.36442563 0,3.36442563 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.71198530339328 9.562695766983337)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.648,0 6.648,6.438 0,6.438 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.45408530339328 6.254895766983336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.6297105,0 3.6297105,6.5165 0,6.5165 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.646985303393277 6.473695766983336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.042,0 6.042,6.193 0,6.193 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.829966777029016 9.470895766983336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.15851853,0 2.15851853,6.5114 0,6.5114 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.312985303393275 16.445995766983337)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.3905,0 3.3905,2.9199 0,2.9199 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.462385303393274 5.777895766983336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.2811,0 2.2811,3.0207 0,3.0207 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.06578530339328 4.099795766983335)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.0772,0 3.0772,1.7076 0,1.7076 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.80118530339328 13.51449576698333)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.13,0 3.13,4.88 0,4.88 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.300985303393274 3.819318876607323)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-3.46944695e-16 6.0331,-3.46944695e-16 6.0331,2.01877689 0,2.01877689 0,-3.46944695e-16",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-8.8817842e-16,-1.11022302e-16 25.9137711,-1.11022302e-16 25.9137711,25.8067264 -8.8817842e-16,25.8067264 -8.8817842e-16,-1.11022302e-16",
    stroke: "none",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.999999999999996 6.999999999999886)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 3.1702411906422014)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.77635684e-15 8.26032036,1.77635684e-15 8.26032036,8.82975881 0,8.82975881 0,1.77635684e-15",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.287366878092088 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.0452376,0 16.0452376,11.8300692 0,11.8300692 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.830142623482075 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4.00245114,0 4.00245114,1.97216842 0,1.97216842 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.60377706001215 3.1913538267936907)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i15)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.58856469,0 7.58856469,8.63871538 0,8.63871538 0,0",
    stroke: "none",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.31444502706396 3.1468380142057235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i16)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-6.66133815e-16 12.4979505,-6.66133815e-16 12.4979505,8.68323119 0,8.68323119 0,-6.66133815e-16",
    stroke: "none",
    fill: "#333333"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEWinLogo);
export default __webpack_public_path__ + "static/media/eWinLogo.e01d7160dc12dc1a7019b099c68e90ac.svg";
export { ForwardRef as ReactComponent };